import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

if (!SECRET_KEY) {
    throw new Error('REACT_APP_SECRET_KEY is not set — refusing to use a default key.');
}

export const encryptAccessToken = (accessToken) => {
    const encryptedToken = CryptoJS.AES.encrypt(accessToken, SECRET_KEY).toString();

    return encryptedToken;
};

export const decryptAccessToken = (encryptedToken) => {
    const bytes = CryptoJS.AES.decrypt(encryptedToken, SECRET_KEY);
    const decryptedAccessToken = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedAccessToken;
};
